import { createSlice } from "@reduxjs/toolkit";
import { RESET } from "../types";

const initialState = {
  deliveryCenter: undefined,
  showDeliveryCenterSetupModal: false,
};

const deliveryCenterSlice = createSlice({
  name: "deliveryCenter",
  initialState,
  reducers: {
    setDeliveryCenter: (state, action) => {
      state.deliveryCenter = action.payload;
    },
    setShowDeliveryCenterSetupModal: (state, action) => {
      state.showDeliveryCenterSetupModal = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(RESET, () => initialState);
  },
});

export const { setDeliveryCenter, setShowDeliveryCenterSetupModal } =
  deliveryCenterSlice.actions;
export default deliveryCenterSlice.reducer;
